/*
  Scene index for keeping track of created scenes.
*/
export default [];
